import { BaseState } from "./BaseState";
import { StateManager } from "../GameStateManager";

class PostRaceState extends BaseState<StateManager> {
  public id = "PostRaceState"; // A unique identifier for the state
  constructor(stateManager: StateManager) {
    super(stateManager); // Pass the StateManager to the base class
  }

  public onEnter(stateManager: StateManager): void {
    this.stateManager = stateManager;
    super.onEnter(stateManager); // Call the super method
    this.stateManager.enteredPostRaceState();

    //wait for 3 seconds then change state
    setTimeout(() => {
      this.stateManager!.changeState(stateManager.postEventState);
    }, 3000);
  }

  public onExit(): void {
    super.onExit();
  }
}

export { PostRaceState };
